import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemAttributeEntity } from '../../domain/entities/ItemAttributeEntity'
import type { SelectionAdminDto } from '@/backend/market'

export class ItemAttributeModel extends ItemAttributeEntity {
  constructor(dataDto: SelectionAdminDto) {
    super()
    mapEntityProperties<ItemAttributeModel>(this, dataDto, {
      map: {
        itemValues: dataDto.itemValues?.map((itemValue) => ({
          name: itemValue.itemName,
          id: itemValue.itemId
        }))
      }
    })
  }
}
